import React from "react";
import {Box, Columns, Heading, Table} from "react-bulma-components";
import DepositRefundRow from "./DepositRefundRow";


export default function DepositRefundSection({data, onPayed, getMissingOffHireItems, triggerChange, onSave}){

    const onChange = (e, index) => {
        triggerChange(e, "deposit_refund", index)
    }

    return (
        <Box>
            <Heading>Deposits to be refunded</Heading>
            <Columns>
                <Columns.Column>
                    <Table>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Registration</th>
                                <th>Customer</th>
                                <th>Offhire Date</th>
                                <th>Deposit</th>
                                <th>Deposit Taken</th>
                                <th>Amount to Refund</th>
                                <th>Missing Items</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.deposit_refund.map((rental, index) => (
                            <DepositRefundRow
                                rental={rental}
                                onPayed={onPayed}
                                getMissingOffHireItems={getMissingOffHireItems}
                                index={index}
                                onChange={onChange}
                                onSave={onSave}
                            />
                        ))}
                        </tbody>
                    </Table>
                </Columns.Column>
            </Columns>
        </Box>
    )



}